import React, { useEffect, useState, } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import deleteIcon from '../assets/delete_icon.svg'
import CommonColorUtils from "../utils/common_colors";
const DeleteDialogBox = ({ open, onClose,titleText,contentText,highlightedContentText,buttonText, callDeleteButton, isDeleteBusy }) => {
    const [isValidateButton, setIsValidateButton] = useState(false);
    const callAssignButton = async () => {
    }
    useEffect(() => {
        if (open) {
            setIsValidateButton(false);
        }
    }, [open])
    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        width: '500px', // Custom width
                        maxWidth: 'none', // Ensure the custom width applies
                    },
                }}
            >
                <DialogTitle
                    style={{
                        fontFamily: 'Inter, Arial, sans-serif',
                        fontWeight: '600',
                        fontSize: '20px',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={deleteIcon} alt="Delete Icon" />
                        <span style={{ padding: '15px' }}>{titleText}</span>
                    </div>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8, // Adjusted for consistent spacing
                            top: 20,
                            width:'50px',// Adjusted for consistent spacing
                            color:CommonColorUtils.primaryGrey700,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div>{contentText}</div>
                    <div
                        style={{
                            fontFamily: 'Inter, Arial, sans-serif',
                            color: '#F32D2D',
                            fontSize: '16px',
                            fontStyle: 'italic',
                            paddingTop: '15px',
                        }}
                    >
                        {highlightedContentText}
                    </div>
                </DialogContent>
                <DialogActions
                    style={{
                        backgroundColor: CommonColorUtils.primaryGrey100,
                        padding: '8px 24px', // Adjust button spacing
                        gap: '12px', // Add gap between buttons
                    }}
                >
                    <Button
                        onClick={onClose}
                        style={{
                            fontFamily: 'Inter, Arial, sans-serif',
                            color: CommonColorUtils.primaryGrey700,
                            fontWeight: '600',
                            fontSize: '14px',
                            textTransform: 'none',
                            width:'100px'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={!open||isDeleteBusy}
                        onClick={isDeleteBusy? ()=>{} : callDeleteButton } 
                        style={{
                            minWidth: '93px',
                            height: '44px',
                            borderRadius: '8px',
                            backgroundColor:isDeleteBusy?CommonColorUtils.primaryErrorLightRed: CommonColorUtils.primaryErrorDarkColor,
                            color: CommonColorUtils.primaryKWhite,
                            fontWeight: '600',
                            fontSize: '14px',
                            fontFamily: 'Inter, Arial, sans-serif',
                            textTransform: 'none',
                        }}
                        sx={{
                            '&.Mui-disabled': {
                            cursor: 'not-allowed',
                            pointerEvents: 'auto', 
                            },
                        }}
                    >
                        {buttonText}
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    );
}

export default DeleteDialogBox;